export default __webpack_public_path__ + "static/media/left-arrow.cc1a9faa.svg";